import Vue from 'vue';
import Router from 'vue-router';
import Index from '../view/index';
import Home from '../view/home';
import Login from "../view/Auth/login";
import AdminLogin from "../view/Auth/adminLogin";
import Cart from "../view/cart";
import About from "../view/Footer/about";
import Contact from "../view/Footer/contact";
import Terms from "../view/Footer/terms";
import Privacy from "../view/Footer/privacy";
import Register from "../view/Auth/register";
import Account from "../view/account";
import Addresses from "../view/addresses";
import Purchase from "../view/purchase";
import Payment from "../view/payment";
import ReturnsAndRefunds from "../view/returnsAndRefunds";
import Confirmation from "../view/confirmation";
import OrderDetail from '../view/Profile/orderDetail';
import Profile from '../view/Profile';
import NotFound from "../view/404";
import WarehouseOrder from '../view/warehouseOrder';
import WarehouseOrderHistory from '../view/warehouseOrderHistory';
import WarehouseOrderHistoryDetail from '../view/warehouseOrderHistoryDetail';

import Inbound from '../view/Service/inbound';
import UpsFedex from '../view/Service/upsFedex';
import OutboundInv from '../view/Service/outboundInv';
import OutboundNoInv from '../view/Service/outboundNoInv';
import OutboundXPO from '../view/Service/outboundXPO';
import OutboundXPONoInv from '../view/Service/outboundXPONoInv';
import Mso from '../view/Service/mso';

import store from '../store';

Vue.use(Router);

async function validateToken(token) {
  //axios request to valida token
  return true
}

// const guard = async (to, from, next) => {
//   try {
//     const token = localStorage.getItem('token');
//     if(token && validateToken(token)) {
//       next('/');
//     } else {
//       next();
//     }
//   } catch(err) {
//     console.log('err find in guard', err);
//   }
// };

const routeToAccount = (to, from, next) => {
  // store.dispatch('addresses/fetchAddresses');
  // store.dispatch('addresses/fetchDefaultAddress');
  // store.dispatch('orders/fetchOrderByTimeFrame', 3);
  // store.dispatch('auth/fetchCustomerInformation');
  next();
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
        }, {
          path: '/login',
          name: 'login',
          // beforeEnter: guard,
          component: Login,
        }, {
          path: '/admin-login',
          name: 'adminLogin',
          component: AdminLogin,
        }, {
          path: '/cart',
          name: 'cart',
          component: Cart,
        }, {
          path: '/about-us',
          name: 'about',
          component: About,
        }, {
          path: '/contact-us',
          name: 'contact',
          component: Contact,
        }, {
          path: '/returns-and-refunds',
          name: 'returns-and-refunds',
          component: ReturnsAndRefunds,
        }, {
          path: '/terms-of-service',
          name: 'terms',
          component: Terms,
        }, {
          path: '/privacy',
          name: 'privacy',
          component: Privacy,
        }, {
          path: '/register',
          name: 'register',
          component: Register,
        }, {
          path: '/account',
          name: 'account',
          component: Profile,
          beforeEnter: routeToAccount,
        }, {
          path: '/addresses',
          name: 'addresses',
          component: Addresses,
        }, {
          path: '/purchase',
          name: 'purchase',
          component: Purchase,
        }, {
          path: '/payment/:so_num',
          name: 'payment',
          component: Payment,
        }, {
          path: '/confirmation',
          name: 'confirmation',
          component: Confirmation,
        }, {
          path: '/order/:order_id',
          name: 'order',
          component: OrderDetail,
        },
        {
          path: '/inbound',
          name: 'inbound',
          component: Inbound,
        },
        // outbound no inventory
        // outbound with inventory
        //  - outbound (ups/fedex)
        //  - xpo (import)
        //  - mso (import)
        
        {
          path: '/outboundXPONoInv',
          name: 'outboundXPONoInv',
          component: OutboundXPONoInv,
        },{
          path: '/outboundInv',
          name: 'outboundInv',
          component: OutboundInv,
        }, {
          path: '/outboundNoInv',
          name: 'outboundNoInv',
          component: OutboundNoInv,
        }, {
          path: '/upsFedex',
          name: 'upsFedex',
          component: UpsFedex,
        },{
          path: '/outboundXPO',
          name: 'outboundXPO',
          component: OutboundXPO,
        }, {
          path: '/mso',
          name: 'mso',
          component: Mso,
        },
        // {
        //   path: '/warehouseOrder',
        //   name: 'warehouseOrder',
        //   component: WarehouseOrder,
        // },
        // {
        //   path: '/warehouseOrderHistory',
        //   name: 'warehouseOrderHistory',
        //   component: WarehouseOrderHistory,
        // },
        // {
        //   path: '/warehouseOrderHistory/:order_id',
        //   name: 'warehouseOrderHistoryDetail',
        //   component: WarehouseOrderHistoryDetail,
        // },
        { path: '*', component: NotFound }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {x: 0, y: 0}
  },
})

router.beforeEach((to, from, next) => {
  // store.dispatch('fetchAccessToken');
  const token = localStorage.getItem('token');
  if (to.fullPath === '/account' || to.fullPath.includes('/order') ||
    to.fullPath === '/inbound' || to.fullPath === '/upsFedex' ||
    to.fullPath === '/mso' || to.fullPath === '/outboundXPO' ||
    to.fullPath === '/outboundXPONoInv') {
    if (!token) {
      next('/login');
    }
  }
  if (to.fullPath === '/login') {
    if (token) {
      next('/account');
    }
  }
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js